import {BaseModel} from "./Base";

export class Collection extends BaseModel {
    items: Array<any> = [];
    
    constructor(data = null) {
        super();
        if(data) {
            Object.keys(data).map((item) => {
                this.items.push(item);
            });
        }
    }
    
    get=() => {
        return this.items;
    }

    set=(data) => {
        this.items.push(data);
        return this.items;
    }
    
}